import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/api/queryClient'
import { AuthProvider } from '@/hooks/useAuth'
import { router } from '@/router/routes'
import { Tooltip } from 'radix-ui'
import { PreferencesProvider } from '@/lib/preferences'

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* Theme, density, favourites (E-UX) and one tooltip provider for every icon button. */}
        <PreferencesProvider>
          <Tooltip.Provider delayDuration={300}>
            <RouterProvider router={router} />
          </Tooltip.Provider>
        </PreferencesProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
